import { FC, memo } from "react";

import __ from "web/Layout/Translations";

import SquarePlus from "web/assets/icons/square-plus.svg";

import classes from "./rentableGroupCalculatorAddPerson.scss";

interface IRentableGroupCalculatorAddPersonProps {
  addPersonCopy: string;
  onClick: () => void;
}

const RentableGroupCalculatorAddPerson: FC<IRentableGroupCalculatorAddPersonProps> =
  memo(({ addPersonCopy, onClick }) => {
    return (
      <button type="button" onClick={onClick} className={classes.addPersonBtn}>
        <SquarePlus width={15} />
        <span className={classes.btnText}>{__(addPersonCopy)}</span>
      </button>
    );
  });
export default RentableGroupCalculatorAddPerson;
